module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/item-serie/item-serie.component.css
// module id = ./src/app/item-serie/item-serie.component.css
// module chunks = main